import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { STReq, STRes, STPage, STComponent, STColumn } from '@delon/abc';
import { NzModalRef } from 'ng-zorro-antd';
import * as $ from 'jquery';
import { ModalHelper, _HttpClient } from '@delon/theme';
import { map } from 'rxjs/operators';
import { deepCopy } from '@delon/util';
import { isString } from 'util';
import { DialogService, IccPatchDialogComponent, IccShortChainConfigComponent } from 'mmmo-mo-common-lib';
import { URLS } from '../../constant/interface';

@Component({
  templateUrl: './wechat-ref.component.html',
  styleUrls: ['./wechat-ref.component.less'],
})
export class WechatRefComponent implements OnInit, AfterViewInit {
  constructor(private http: _HttpClient, private dialogService: DialogService, private modal: NzModalRef, private modalHelper: ModalHelper, private modalHelpler: ModalHelper) {}
  title = '引用模板';
  subject = '微信模板引用';
  url = URLS.templateWechatTemplate.url;
  selectedBizType;
  template;
  isVisible = false;
  startIndex = 1;
  /** 编辑的模板 */
  selectTemplate: any = {
    id: null,
    title: null,
    content: null,
    url: '',
    templateId: null,
  };
  /** 业务变量 */
  variableBinds = [];
  /** 参数变量列表 */
  varList = [];
  /** 预览内容 */
  contentPreview: string = null;

  req: STReq = {
    type: 'page',
    method: 'POST',
    allInBody: true,
    lazyLoad: true,
  };

  searchParams = {
    title: null,
  };

  // 是否是编辑
  isEdit = false;

  @ViewChild('st', { static: false }) st: STComponent;
  columns: STColumn[] = [
    { title: '模板标题', index: 'title', render: 'titleTemp' },
    { title: '模板内容', index: 'content', render: 'contentTemp' },
    { title: '模板示例', index: 'example', render: 'exampleTemp' },
    {
      title: '操作',
      buttons: [
        {
          text: '选择',
          click: data => {
            this.isVisible = true;
            this.handleVarList(data);
            this.changePreview();
          },
        },
      ],
    },
  ];

  ngOnInit() {
    const { templateId, id, channelId } = this.selectedBizType;
    // 编辑
    if (templateId) {
      this.isEdit = true;
      this.getTemplateById({ templateId, channelId }).subscribe(list => {
        if (list) {
          this.handleTemplateVarMap(list);
          this.changePreview();
        }
      });
    } else {
      // 新增
      this.req.params = {
        params: {
          bizTypeId: id,
          channelId,
        },
      };
    }
  }
  /** 处理变量列表 */
  handleVarList(data) {
    this.selectTemplate = data;
    this.isVisible = true;
    const matches = data.content.match(/\{\{[a-zA-Z0-9_\-\.]+\}\}/g);
    this.varList = [];
    if (matches) {
      matches.forEach(match => {
        this.varList.push({ value: match, replace: null, facus: false, vIndex: 0 });
      });
    }

    const { varMap } = this.template;
    // varMap.url;
    if (varMap && varMap.url) this.selectTemplate.url = varMap.url === null || varMap.url === undefined ? '' : varMap.url;
  }
  /** 处理模板数据 */
  handleTemplateVarMap(data) {
    this.selectTemplate = data;
    this.selectTemplate.requireShortUrl = this.template.requireShortUrl;
    this.selectTemplate.longUrlName = this.template.longUrlName;
    this.selectTemplate.longUrl = this.template.longUrl;
    this.selectTemplate.serverUrl = this.template.serverUrl;
    this.selectTemplate.targetUrlId = this.template.targetUrlId;
    this.selectTemplate.traceType = this.template.traceType;

    this.varList = [];
    const { varMap } = this.template;

    Object.keys(varMap).forEach(it => {
      if (it.indexOf('.DATA') > -1) {
        this.varList.push({ value: `{{${it}}}`, replace: varMap[it], facus: false, vIndex: 0 });
      }
      if (it.indexOf('url') > -1) {
        this.selectTemplate.url = varMap[it] === null || varMap[it] === undefined ? '' : varMap[it];
      }
    });
  }
  /** 获取表格数据 */
  getTableList() {
    this.st.reset({
      params: {
        bizTypeId: this.selectedBizType.id,
        channelId: this.selectedBizType.channelId,
        title: this.searchParams.title,
      },
    });
  }

  /** 输入框聚焦 */
  varClcik(v, ev) {
    this.chnageSelection(ev);
    this.varList.forEach(va => (va.focus = false));
    v.focus = true;
  }

  /** 改变焦点位置 */
  chnageSelection(ev) {
    if (ev && ev.target) {
      this.startIndex = ev.target.selectionStart;
    }
  }

  /** 插入资源 */
  insertSource(patch) {
    this.varList.some(va => {
      const { focus, replace } = va;
      const target = replace ? replace : '';
      if (focus) {
        const startStr = target.substring(0, this.startIndex);
        const endStr = target.substring(this.startIndex, target.length);
        va.replace = startStr + '${' + patch.code + '}' + endStr; // patch.code
        va.focus = false;
        return;
      }
    });
    this.changePreview();
  }

  /** 打开贴片弹窗 */
  openPatchModal() {
    if (!this.validateBeforeOpenPatchModal()) return;
    this.modalHelpler
      .create(
        IccPatchDialogComponent,
        {
          content: this.contentPreview,
          msgType: this.template.msgType,
          contentType: 2,
          groupUrl: URLS.templatePatchGroup.url,
          itemUrl: URLS.templatePatchGroupItem.url,
        },
        { size: 'lg' },
      )
      .subscribe(patch => this.processPatch(patch));
  }

  /** 添加贴片前的验证 */
  validateBeforeOpenPatchModal() {
    const { patchStrategy } = this.template;

    if (!this.varList.some(v => v.focus)) {
      this.dialogService.notification.error(this.subject, '请先选中参数再选择贴片');
      return;
    }
    // 限制贴片数量
    if (patchStrategy && this.contentPreview) {
      const result = patchStrategy.filter(paster => this.contentPreview.indexOf('${' + paster.groupName + '}') >= 0);
      if (result.length >= 3) {
        this.dialogService.notification.warning('注意', `最多只能添加三个贴片`);
        return;
      }
    }
    return true;
  }
  /** 处理贴片 */
  processPatch(source) {
    // let { patchStrategy } = this.template;
    if (this.contentPreview.indexOf('${' + source.groupName + '}') !== -1) {
      this.dialogService.notification.warning(this.subject, `每个贴片在模板中只能使用一次`);
      return;
    }
    this.insertSource({ code: source.groupName });
    if (this.template.patchStrategy) {
      // 处理结构化贴片策略数据
      let i = this.template.patchStrategy.findIndex(ps => ps.groupId === source.groupId);
      if (i >= 0) {
        this.template.patchStrategy.splice(i, 1);
      }
      this.template.patchStrategy.push(source);
    } else {
      this.template.patchStrategy = [source];
    }
  }

  /** 添加业务变量 */
  insertvariable(source) {
    this.validateBeforeInsertvariable();
    this.insertSource(source);
  }

  /** 添加业务变量前的验证 */
  validateBeforeInsertvariable() {
    if (!this.varList.some(v => v.focus)) {
      this.dialogService.notification.error(this.subject, '请选中参数再添加业务变量');
      return;
    }
    return true;
  }

  /** 实时预览 */
  changePreview() {
    this.contentPreview = deepCopy(this.selectTemplate.content);
    for (const v of this.varList) {
      const { value, replace } = v;
      if (replace) this.contentPreview = this.contentPreview.replace(value, replace);
    }
  }

  /** 确定 */
  handleOk() {
    const varMap: any = {};
    const { url, templateId, id, requireShortUrl, longUrlName, longUrl, serverUrl, targetUrlId, traceType } = this.selectTemplate;
    varMap.__template_id__ = templateId;
    varMap.url = url;
    if (this.varList) {
      for (let v of this.varList) {
        const { value, replace } = v;

        if (!replace) {
          this.dialogService.notification.error(this.subject, '存在参数未进行修改。');
          return;
        }

        if (url) {
          const reg = /\s+/g;
          const length = url.search(reg);
          if (length > -1) {
            this.dialogService.notification.error(this.subject, 'URL链接不允许携带空格');
            return;
          }
        }

        this.contentPreview = this.contentPreview.replace(value, replace);

        const _value = value.replace('{{', '').replace('}}', '');
        varMap[_value] = v.replace;
      }
    }

    if (this.contentPreview && this.contentPreview.length > 200) {
      this.dialogService.notification.error(this.subject, '模板长度不得超过200字符');
      return;
    }

    this.isVisible = false;
    this.modal.close({
      content: this.contentPreview,
      id,
      varMap,
      requireShortUrl: requireShortUrl,
      longUrlName: longUrlName,
      longUrl: longUrl,
      serverUrl: serverUrl,
      targetUrlId: targetUrlId,
      traceType: traceType,
    });
  }

  /** 获取指定id的模板 */
  getTemplateById(payload) {
    const params = {
      params: { ...payload },
      pi: 1,
      ps: 10,
    };

    return this.http.post(this.url, params).pipe(
      map(data => {
        const { status, list } = data;
        if (status === 0) return list[0];
        else {
          this.dialogService.notification.error(this.subject, `模板获取失败，请重新获取`);
          return false;
        }
      }),
    );
  }

  returnBack() {
    this.modal.close();
  }

  search() {
    this.getTableList();
  }

  ngAfterViewInit() {
    if (this.st) this.st.load();
  }

  /* 打开短链配置弹窗 */
  OpenShortChainModal(template) {
    if (isString(template.url) && template.url.includes('${短链接}')) {
      this.dialogService.notification.error('微信模板', '已存在短链,请擦除后再插入。');
      return;
    }
    this.modalHelper.createStatic(IccShortChainConfigComponent, { template }, { size: 'md' }).subscribe(result => {
      const { longUrlName, longUrl, serverUrl, traceType, targetUrlId } = result;
      // 无uuid，用 requireShortUrl 代替
      template.requireShortUrl = true;
      template.longUrlName = longUrlName;
      template.longUrl = longUrl;
      template.serverUrl = serverUrl;
      template.targetUrlId = targetUrlId;
      template.traceType = traceType;

      template.url = '${短链接}';
    });
  }
}
